import { useMutation } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { Category } from "@modules/categorys/types";
import { CategoryFormValues } from "@modules/categorys/validations";
import { editCategoryService } from "./service";
import { UseEditCategoryMutationOptions } from "./types";
import { Optional } from "@shared/types";

export function useEditCategoryMutation(
  options?: UseEditCategoryMutationOptions
) {
  const { open } = useNotification();
  const translate = useTranslate();

  return useMutation<Category, ApiError, { id: string; data: Optional<CategoryFormValues, "name"> }>({
    mutationFn: ({ id, data }) => editCategoryService(id, data),
    onSuccess: () => {
      open?.({
        type: "success",
        message: translate("category_admin.success.edit"),
      });
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
